const getIsLoading = (state) => { return state.isLoading }

const getAgents = (state) => { return state.agents }

const getClients = (state) => { return state.clients }

const getFinanceReportData = (state) => { return state.financeReportData }

const getInputTransaction = (state) => { return state.input_transaction }
const getOutputTransaction = (state) => { return state.output_transaction }

const getRequestArrayStatus = (state) => { return state.requestArrayStatus }

const getInputTransactionsList = (state) => { return state.inputTransactions }
const getOutputTransactionsList = (state) => { return state.outputTransactions }

const getResponseInputFilter = (state) => { return state.responseInputFilter }
const getResponseOutputFilter = (state) => { return state.responseOutputFilter }

const getSuperArrayInputTransactions = (state) => { return state.superArrayInputTransactions }
const getSuperArrayOutputTransactions = (state) => { return state.superArrayOutputTransactions }

export default {
    getIsLoading,
    getAgents,
    getClients,
    getInputTransaction,
    getOutputTransaction,
    getRequestArrayStatus,
    getInputTransactionsList,
    getOutputTransactionsList,
    getResponseInputFilter,
    getResponseOutputFilter,
    getSuperArrayInputTransactions,
    getSuperArrayOutputTransactions,
    getFinanceReportData,
}